/** Modale « Nouvelle société » — même fiche que le premier écran. */
import { useEffect } from "react";
import { CompanyCreateForm } from "./CompanyCreateForm";
import "../components/confirmModal.css";

type CompanyCreateModalProps = {
  open: boolean;
  onClose: () => void;
  onDone: () => void;
};

export function CompanyCreateModal({ open, onClose, onDone }: CompanyCreateModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fx-modal" role="dialog" aria-modal="true" aria-labelledby="fx-create-title">
      <button type="button" className="fx-modal__backdrop" aria-label="Fermer" onClick={onClose} />
      <div className="fx-modal__card is-create">
        <h2 id="fx-create-title" className="fx-modal__title">
          Nouvelle société
        </h2>
        <CompanyCreateForm
          onCancel={onClose}
          onDone={() => {
            onDone();
            onClose();
          }}
        />
      </div>
    </div>
  );
}
